import { render, staticRenderFns } from "./wdIndex.vue?vue&type=template&id=730969fc&scoped=true&"
import script from "./wdIndex.vue?vue&type=script&lang=js&"
export * from "./wdIndex.vue?vue&type=script&lang=js&"
import style0 from "./wdIndex.vue?vue&type=style&index=0&id=730969fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730969fc",
  null
  
)

export default component.exports